import * as c from '../constants';

export const getSession = (entryPath) => ({
  type: c.GET_SESSION,
  payload:{entryPath}
});

export const loginMeta = (entryPath) => ({
  type: c.LOGIN_META,
  payload:{entryPath}
});


export const logoutRequested = () => ({
  type: c.LOGOUT_REQUESTED
});

export const logoutSucceeded = () => ({
  type: c.LOGOUT_SUCCEEDED
});

export const logoutFailed = error => ({
  type: c.LOGOUT_FAILED,
  payload: { error }
});

export const loginSucceeded = user => ({
  type: c.LOGIN_SUCCEEDED,
  payload: { user }
});

export const loginFailed = error => ({
  type: c.LOGIN_FAILED,
  payload: { error }
});

export const toggleUserApproved = (id,isApproved) => ({
  type: c.TOGGLE_USER_APPROVED,
  payload: {id, isApproved}
})

export const updateMatchesRequested = () => ({
  type: c.UPDATE_MATCHES_REQUESTED
});

export const updateMatchesWith = (data) => ({
  type: c.UPDATE_MATCHES_WITH,
  payload: {...data}
});

export const updateMatchesStarted = () => ({
  type: c.UPDATE_MATCHES_STARTED
});

export const updateMatchesEnded = () => ({
  type: c.UPDATE_MATCHES_ENDED
});

export const toggleMatchApproved = (id,isApproved) => ({
  type: c.TOGGLE_MATCH_APPROVED,
  payload: { id, isApproved }
});



// WEBPACK FOOTER //
// ./src/actions/index.js